import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import ScrollToTop from "./components/ScrollToTop";

ReactDOM.render(<>
  <BrowserRouter>
    <App />
    <ScrollToTop /></BrowserRouter>
    </>
  ,
  document.getElementById('root')
);

